import { render } from "./BuildingUnitDisplay.vue?vue&type=template&id=5640638c&scoped=true"
import script from "./BuildingUnitDisplay.vue?vue&type=script&lang=js"
export * from "./BuildingUnitDisplay.vue?vue&type=script&lang=js"

import "./BuildingUnitDisplay.vue?vue&type=style&index=0&id=5640638c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5640638c"]])

export default __exports__